export default __webpack_public_path__ + "images/icon_45303f.svg";